import React from 'react';
import { ReplyIcon, TagIcon, UserCircleIcon } from "@heroicons/react/solid";

const typeIconTypeMap = {
    'reply': ReplyIcon,
    'assignment': UserCircleIcon,
    'tags': TagIcon
};

export default function ActivityIcon({type, imageUrl}) {

    const Icon = typeIconTypeMap[type];

    if (imageUrl) {
        return <>
            <img
                className="h-10 w-10 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white"
                src={imageUrl}
                alt=""
            />

            {
                Icon && <span className="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px">
                    <Icon className="h-5 w-5 text-gray-400" aria-hidden="true"/>
                </span>
            }
        </>;
    }

    if (! Icon) {
        return <div className="w-10" />;
    }

    return <div className="relative px-1 min-w-8">
        <div className="h-8 w-8 bg-gray-100 rounded-full ring-8 ring-white flex items-center justify-center">
            <Icon className="h-5 w-5 text-gray-500" aria-hidden="true" />
        </div>
    </div>;
};
